module.exports = __webpack_public_path__ + "static/media/file-psd.0cebe55f.svg";